// ##### 24-05-29 Komarov
import { SET_SITE_PAGE_LIST_SECTION } from '../constants';

export const setSitePageListSection = pagesInfoArray => dispatch => {
  dispatch({
    type: SET_SITE_PAGE_LIST_SECTION,
    payload: pagesInfoArray,
  });
};
